(() => {
  const init = () => {
    const drawer = document.getElementById('iurop-search');
    if (!drawer) return;

    const input = drawer.querySelector('#iurop-search-input');
    const defaultView = drawer.querySelector('[data-search-default]');
    const resultsView = drawer.querySelector('[data-search-results]');
    const resultsGrid = drawer.querySelector('[data-search-results-grid]');
    const emptyState = drawer.querySelector('[data-search-empty]');
    const loadingState = drawer.querySelector('[data-search-loading]');
    const clearBtn = drawer.querySelector('[data-search-clear]');
    const header = document.querySelector('[data-header]');

    let debounce = null;
    let reqId = 0;

    const positionPanel = () => {
      if (!header) return;
      const rect = header.getBoundingClientRect();
      const top = Math.max(0, rect.bottom);
      drawer.style.setProperty('--iurop-search-top', `${top}px`);
    };

    const open = () => {
      positionPanel();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('iurop-search-open');
      // Opening restyles the header (solid), so its measured bottom can be stale
      // for the first frame — re-measure across the next frames so the panel
      // doesn't open with a strip of the page showing above it. (This is the
      // correction a manual 1px scroll used to trigger.)
      requestAnimationFrame(() => {
        positionPanel();
        requestAnimationFrame(positionPanel);
      });
      setTimeout(positionPanel, 120);
      setTimeout(() => input && input.focus(), 120);
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('iurop-search-open');
      if (input) input.value = '';
      if (clearBtn) clearBtn.hidden = true;
      showDefault();
    };

    const FADE_MS = 180;
    let swapTimer = null;

    const swapView = (toResults) => {
      const enter = toResults ? resultsView : defaultView;
      const leave = toResults ? defaultView : resultsView;

      if (!leave.hidden) {
        leave.classList.add('is-fading');
      }

      clearTimeout(swapTimer);
      swapTimer = setTimeout(() => {
        leave.hidden = true;
        leave.classList.remove('is-fading');

        enter.hidden = false;
        enter.classList.add('is-entering');
        // Two RAFs ensure the browser paints the initial state before transitioning.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            enter.classList.remove('is-entering');
          });
        });
      }, leave.hidden ? 0 : FADE_MS);
    };

    const showDefault = () => {
      reqId += 1;
      loadingState.hidden = true;
      emptyState.hidden = true;
      resultsGrid.innerHTML = '';
      swapView(false);
    };

    const showResults = () => {
      swapView(true);
    };

    const performSearch = (query) => {
      const currentReq = ++reqId;
      showResults();
      loadingState.hidden = false;
      emptyState.hidden = true;

      const url = `${(window.routes && window.routes.predictive_search_url) || '/search/suggest'}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag&section_id=iurop-predictive-search`;

      fetch(url, { headers: { Accept: 'text/html' } })
        .then((r) => {
          if (!r.ok) throw new Error(r.statusText);
          return r.text();
        })
        .then((html) => {
          if (currentReq !== reqId) return;
          loadingState.hidden = true;

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('#shopify-section-iurop-predictive-search');
          const results = section ? section.querySelector('#predictive-search-results') : null;

          if (!results) {
            resultsGrid.innerHTML = '';
            emptyState.hidden = false;
            return;
          }

          const grid = results.querySelector('.iurop-search__grid');
          const count = parseInt(results.getAttribute('data-result-count') || '0', 10);

          if (grid && count > 0) {
            resultsGrid.innerHTML = grid.innerHTML;
            emptyState.hidden = true;
          } else {
            resultsGrid.innerHTML = '';
            emptyState.hidden = false;
          }
        })
        .catch(() => {
          if (currentReq !== reqId) return;
          loadingState.hidden = true;
          resultsGrid.innerHTML = '';
          emptyState.hidden = false;
        });
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-search-trigger]');
      if (trigger) {
        e.preventDefault();
        open();
        return;
      }
      if (e.target.closest('[data-search-close]')) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    drawer.querySelectorAll('[data-search-term]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const term = btn.getAttribute('data-search-term');
        if (!term) return;
        input.value = term;
        performSearch(term);
      });
    });

    const updateClearVisibility = () => {
      if (!clearBtn) return;
      clearBtn.hidden = !input || input.value.length === 0;
    };

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (!input) return;
        input.value = '';
        clearTimeout(debounce);
        updateClearVisibility();
        showDefault();
        input.focus();
      });
    }

    if (input) {
      input.addEventListener('input', () => {
        updateClearVisibility();
        const query = input.value.trim();
        clearTimeout(debounce);
        if (!query) {
          showDefault();
          return;
        }
        debounce = setTimeout(() => performSearch(query), 220);
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') e.preventDefault();
      });
    }

    window.addEventListener('resize', () => {
      if (drawer.classList.contains('is-open')) positionPanel();
    });
    window.addEventListener('scroll', () => {
      if (drawer.classList.contains('is-open')) positionPanel();
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
